import React from "react";

import { Toolbar } from "primereact/toolbar";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";

// wrappers for prime react form fields
import FieldInputText from "../common/FieldInputText";
import FieldInputTextarea from "../common/FieldInputTextarea";
import FieldCalendar from "../common/FieldCalendar";

const ClientDetailsDialogFooter = ({
  submitForm,
  isAdd,
  canSave,
  deleteClient,
  currentClient,
  isAnnualReturn,
  isAdmin,
  saveClient,
  saveAndAddClient,
}) => {
  return (
    <React.Fragment>
      {canSave && (
        <Toolbar>
          <div className="p-toolbar-group-left">
            {isAnnualReturn === true && (
              <Button
                label="Save"
                icon="pi pi-check"
                onClick={() => saveClient(submitForm)}
              />
            )}
            {isAnnualReturn !== true && (
              <Button label="Save" icon="pi pi-check" onClick={submitForm} />
            )}
          </div>
          {isAnnualReturn === true && (
            <div className="p-toolvar-group-right">
              <Button
                label="Save &amp; Add"
                icon="pi pi-plus"
                onClick={() => saveAndAddClient(submitForm)}
              />
            </div>
          )}
          {isAdmin === true && (
            <div className="p-toolbar-group-right">
              {isAdd === false && isAnnualReturn === false && (
                <Button
                  icon="pi pi-times"
                  className="p-button-danger"
                  label="Delete"
                  onClick={() => deleteClient(currentClient.ClientId)}
                />
              )}

              {/* {isAdd === false && isAnnualReturn === false && <ConfirmDialog buttonLabel="Delete" buttonIcon="pi pi-times" buttonIconPos="left" buttonClassName="p-button-danger" handleOnYesClick={() => deleteClient(currentClient.ClientId)}
            title={'Confirm client deletion'} message={'Are you sure you wish to delete this client?'}
          />} */}
            </div>
          )}
        </Toolbar>
      )}
    </React.Fragment>
  );
};

const ClientDetails = ({
  currentClient,
  canSave,
  submitForm,
  resetForm,
  isAdd,
  deleteClient,
  isDisplayingDialog,
  closeClientDetails,
  isAnnualReturn,
  isAdmin,
  saveClient,
  saveAndAddClient,
  employeeOptions,
}) => {
  let validationRules = currentClient.ValidationRules
    ? currentClient.ValidationRules.$values
    : [];
  let showAsTextOnly = canSave === false;
  let dialogFooter = (
    <ClientDetailsDialogFooter
      submitForm={submitForm}
      isAdd={isAdd}
      canSave={canSave}
      deleteClient={deleteClient}
      currentClient={currentClient}
      isAnnualReturn={isAnnualReturn}
      isAdmin={isAdmin}
      saveClient={saveClient}
      saveAndAddClient={saveAndAddClient}
    />
  );
  return (
    <Dialog
      visible={isDisplayingDialog}
      header="Client Details"
      modal={true}
      footer={dialogFooter}
      onHide={() => {
        closeClientDetails(currentClient, resetForm);
      }}
    >
      <div className="p-grid">
        <div className="p-col-12">
          <FieldInputText
            field={"Name"}
            label={"Client Name"}
            validationRules={validationRules}
            showAsTextOnly={showAsTextOnly || isAnnualReturn}
          />
        </div>
        {isAnnualReturn === false && (
          <div className="p-col-6">
            <FieldCalendar
              field={"StartDate"}
              label={"Start Date"}
              validationRules={validationRules}
              showAsTextOnly={showAsTextOnly}
              viewDate={currentClient.StartDate}
            />
          </div>
        )}
        {isAnnualReturn === false && (
          <div className="p-col-6">
            <FieldCalendar
              field={"EndDate"}
              label={"End Date"}
              validationRules={validationRules}
              showAsTextOnly={showAsTextOnly}
              viewDate={currentClient.EndDate}
            />
          </div>
        )}
        {isAnnualReturn === true && (
          <div className="p-col-12">
            <FieldInputText
              field={"SubjectDiscussed"}
              label={"Subject Discussed"}
              validationRules={validationRules}
              showAsTextOnly={showAsTextOnly}
            />
          </div>
        )}
        {isAnnualReturn === true && (
          <div className="p-col-12">
            <FieldInputTextarea
              rows={3}
              field={"PublicOfficialMet"}
              label={"Name of Public Official(s)"}
              validationRules={validationRules}
              showAsTextOnly={showAsTextOnly}
            />
          </div>
        )}
      </div>
    </Dialog>
  );
};

export default ClientDetails;



// WEBPACK FOOTER //
// ./src/components/client/client-details.js